function removeFromTo(array, from, to) {
  array.splice(
    from,
    !to ||
      1 +
        to -
        from +
        (!((to < 0) ^ (from >= 0)) && (to < 0 || -1) * array.length)
  );
  return array.length;
}

const UndoManager = () => {
  let commands = [];
  let index = -1;
  let limit = 0;
  let isExecuting = false;
  let callback;
  let isGroupExecutionEnded = true;
  let isUndoManagerDisabled = false;

  const execute = (command, action) => {
    if (!command || typeof command[action] !== 'function') {
      return this;
    }
    isExecuting = true;

    command[action]();

    isExecuting = false;
    return this;
  };

  const executeBeginGroupOnUndoAction = () => {
    isGroupExecutionEnded = true;
    return this;
  };

  const executeBeginGroupOnRedoAction = () => {
    isGroupExecutionEnded = false;
    const startIndex = index;
    for (let i = startIndex + 1; i < commands.length; i++) {
      const command = commands[i];
      index += 1;
      execute(command, 'redo');
      if (isGroupExecutionEnded) {
        break;
      }
    }
    if (callback) {
      callback();
    }
  };

  const executeEndGroupOnUndoAction = () => {
    isGroupExecutionEnded = false;
    const startIndex = index;
    for (let i = startIndex; i >= 0; i--) {
      const command = commands[i];
      index -= 1;
      execute(command, 'undo');
      if (isGroupExecutionEnded) {
        break;
      }
    }
    if (callback) {
      callback();
    }
  };

  const executeEndGroupOnRedoAction = () => {
    isGroupExecutionEnded = true;
    return this;
  };

  return {
    /*
            Add a command to the queue.
            */
    add(command) {
      if (isExecuting) {
        return this;
      }
      if (isUndoManagerDisabled) {
        return this;
      }

      // if we are here after having called undo,
      // invalidate items higher on the stack
      commands.splice(index + 1, commands.length - index);

      commands.push(command);

      // if limit is set, remove items from the start
      if (limit && commands.length > limit) {
        removeFromTo(commands, 0, -(limit + 1));
      }

      // set the current index to the end
      index = commands.length - 1;
      if (callback) {
        callback();
      }
      return this;
    },

    /*
            Pass a function to be called on undo and redo actions.
            */
    setCallback(callbackFunc) {
      callback = callbackFunc;
    },

    /*
            Perform undo: call the undo function at the current index and decrease the index by 1.
            */
    undo() {
      const command = commands[index];
      if (!command) {
        return this;
      }
      index -= 1;
      execute(command, 'undo');
      if (callback) {
        callback();
      }
      return this;
    },

    /*
                  Perform redo: call the redo function at the next index and increase the index by 1.
                 */

    redo() {
      const command = commands[index + 1];
      if (!command) {
        return this;
      }
      index += 1;
      execute(command, 'redo');
      if (callback) {
        callback();
      }
      return this;
    },

    /*
            Clears the memory, losing all stored states. Reset the index.
            */
    clear() {
      const prevSize = commands.length;

      commands = [];
      index = -1;

      if (callback && prevSize > 0) {
        callback();
      }
    },

    hasUndo() {
      return index !== -1;
    },

    hasRedo() {
      return index < commands.length - 1;
    },

    getCommands() {
      return commands;
    },

    getIndex() {
      return index;
    },

    setLimit(l) {
      limit = l;
    },

    beginGroup() {
      this.add({
        undo() {
          executeBeginGroupOnUndoAction();
        },
        redo() {
          executeBeginGroupOnRedoAction();
        }
      });
    },

    endGroup() {
      this.add({
        undo() {
          executeEndGroupOnUndoAction();
        },
        redo() {
          executeEndGroupOnRedoAction();
        }
      });
    },

    disableUndo() {
      isUndoManagerDisabled = true;
    },

    enableUndo() {
      isUndoManagerDisabled = false;
    },

    getUndoEnableState() {
      return !isUndoManagerDisabled;
    },

    getUndoStackIndex() {
      return index;
    }
  };
};

export default UndoManager;
